import { TuneOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { UIactions } from "../../../../../store/slices/UI";
import IconButton from "../../../GeneralPurpose/IconButton";

const AdvancedSearchButton = ({ modalType = "advanced-mail-filter" }) => {
  const dispatch = useDispatch();

  const handleClick = (e) => {
    dispatch(UIactions.openModal({ type: modalType }));
  }

  return (
    <IconButton
      {...{
        id: "advancedFilter",
        icon: <TuneOutlined />,
        size: "small",
        fontSize: "1.5rem",
        disabled: false,
        UIText: {
          "es-CL": { fixedTooltip: "Busqueda avanzada" },
          "en-US": { fixedTooltip: "Advanced filter" },
        },
        onClick: handleClick,
      }}
    />
  );
};

export default AdvancedSearchButton;